/**
 * The logger's catalog writes dates as dd/mm/yyyy (its rows show days above 12 in the first
 * field, e.g. 15/08/2026, never in the second). Both orders are tried when the fields are
 * ambiguous; a reading that lands in the future cannot be right, so the other order is used.
 */
export function catalogDate(date: string, time: string | undefined, now = new Date()): Date | null {
  const [a, b, y] = date.split('/').map(Number)
  const [hh = 0, mm = 0, ss = 0] = (time ?? '').split(':').map(Number)
  if (!a || !b || !y) return null
  const make = (d: number, m: number) => {
    if (m < 1 || m > 12 || d < 1 || d > 31) return null
    const out = new Date(y, m - 1, d, hh, mm, ss)
    return Number.isNaN(out.getTime()) ? null : out
  }
  const dayFirst = make(a, b)
  const monthFirst = make(b, a)
  const future = (x: Date | null) => x != null && x.getTime() > now.getTime() + 24 * 3600 * 1000
  if (dayFirst && !future(dayFirst)) return dayFirst
  if (monthFirst && !future(monthFirst)) return monthFirst
  return dayFirst ?? monthFirst
}
